module.exports = __webpack_public_path__ + "static/img/4自动驾驶作业决策控制.d85bb6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/解决方案/农机无人驾驶解决方案/4自动驾驶作业决策控制.png
// module id = MYeA
// module chunks = 0